export class KeyValueStore<T> {
  private map: Record<string, T>;

  constructor(arr: T[]) {
    this.map = {};
    this.parse(arr);
  }

  parse(arr: (string[] | T)[]) {
    if (arr.length % 2 !== 0) {
      throw new Error('Array must contain an even number of elements (key-value pairs).');
    }

    if (arr.length === 0) {
      return {};
    }

    this.map = {};
    for (let i = 0; i < arr.length; i += 2) {
      const key = arr[i];
      const value = arr[i + 1];
      if (key && value) {
        this.map[String(key)] = value as T;
      } else {
        console.warn(`Invalid key-value pair: ${key}, ${value}`);
      }
    }
  }

  get(key: string): T {
    return this.map[key];
  }

  set(key: string, value: T): void {
    this.map[key] = value;
  }

  forEach(callback: (key: string, value: T) => void): void {
    Object.entries(this.map).forEach(([key, value]) => {
      callback(key, value);
    });
  }

  asObject(): Record<string, T> {
    return { ...this.map };
  }
}
